import { createFileRoute, redirect } from '@tanstack/react-router';

import { agentBrokerSections } from '@/features/agents-brokers';

/*
 * Bare `/agents-brokers/:id` redirects to the first section (profile), matching
 * the prototype's default-section behavior. The sectioned view lives in
 * `$agentBrokerId/$section`.
 */
export const Route = createFileRoute('/_auth/agents-brokers/$agentBrokerId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/agents-brokers/$agentBrokerId/$section',
      params: {
        agentBrokerId: params.agentBrokerId,
        section: agentBrokerSections[0]!.id,
      },
      replace: true,
    });
  },
});
